<template>
  <label>
    <div v-show="is_add_tag" class="styledSelect styledSelect--simple">
      <select :name="name"
              :value="modelValue"
              @change="updateValue"
              :class="class_name"
              @focus="$emit('focus', $event)"
              @blur="$emit('blur', $event)" >

        <slot :options="options"></slot>
      </select>
    </div>
    <select v-show="!is_add_tag"
            :name="name"
            :value="modelValue"
            @change="updateValue"
            :class="class_name"
            @focus="$emit('focus', $event)"
            @blur="$emit('blur', $event)" >

        <slot :options="options"></slot>
      </select>
  </label>
</template>
<script>
  export default {
    props: {
      modelValue: {},
      class_name: { type: Array },
      name: { type: String, require: true },
      options: { type: Array, required: true },
      is_add_tag: { type: Boolean, default: true }
    },

    methods: {
      updateValue: function(e) {
        let value = e.target.selectedIndex !== 0 ? this.options[e.target.selectedIndex].value : null
        this.$emit('update:modelValue', value)
        this.$emit('selected', value)
      }
    }
  }
</script>
